FlipsterDefaults = require 'app/views/shared/flipster_defaults'

class DF.Views.Settings extends Backbone.Enhanced.View

  el: '.settings .settings-content'
  flipsterObject: {}

  events:
    'click .page-selectors .selector' : '_onSelectorClick'
    'click .filters .button.filter' : '_onFilterClick'

  initialize: ->
    super
    @listenTo(DF.Events, 'settings:render', @render)
    @listenTo(DF.Events, 'settings:page', @_changePage)
    @listenTo(DF.Events, 'settings:show', @_showSelector)
    @listenTo(DF.Events, 'settings:hide', @_hideSelector)

  render: ->
    super
    @_setupFlipster()
    @_changePage 0

  teardown: ->
    super

  _setupFlipster: ->
    config = Object.assign(FlipsterDefaults, {click: false})

    # we need this because settings pages are 100% width,
    # and goofy stuff happens if you don't overlap them with -1
    config.spacing = -1
    @flipsterObject = @$el.flipster config

  _onSelectorClick: (e) ->
    id = $(e.currentTarget).data('page')
    @_changePage id

  _showSelector: (id) ->
    @$el.find(".page-selectors .selector[data-page=#{id}]").removeClass 'hide'

  _hideSelector: (id) ->
    @$el.find(".page-selectors .selector[data-page=#{id}]").addClass 'hide'

  _changePage: (id) ->
    @$el.find('.page-selectors .selector').removeClass 'active'
    @$el.find(".page-selectors .selector[data-page=#{id}]").addClass 'active'

    items = @$el.find('.flipster-container .flipster-item')
    item = @$el.find(".flipster-container .flipster-item[data-page=#{id}]")
    @flipsterObject.flipster('jump', item)
    return

  _onFilterClick: (e) ->
    # @$el.find('.filters .button.filter').removeClass('active')
    # $(e.target).addClass('active')
    DF.Events.trigger('settings:filter', e)

module.exports = DF.Views.Settings